import { useNavigate, useSearchParams } from 'react-router-dom';
import EntityDialog from '../../EntityDialog';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { denyUserRequestToAccessOrganization } from '../../hooks/useUsers';
import { getErrorMessage } from '../../utils/requestErrors';
import isValidEmail from '../../utils/valEmail';
import useRequestedOrganizationSelection from '../../hooks/useRequestedOrganizationSelection';

export default function DenyUserContainer() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { org } = useLegacyAppSession();
  const requestedOrganizationName = String(searchParams.get('organization') || '');
  const {
    isResolvingOrganization,
    organizationResolutionError,
  } = useRequestedOrganizationSelection(requestedOrganizationName);

  return (
    <EntityDialog
      title="Deny User Request to Access Organization"
      contextLabel="Users"
      testId="deny-user"
      fields={[
        { name: 'name', label: 'Name', required: true, readOnly: true },
        { name: 'email', label: 'Email', required: true, readOnly: true },
        { name: 'organization', label: 'Organization', required: true, readOnly: true },
      ]}
      initialValues={() => ({
        name: String(searchParams.get('name') || ''),
        email: String(searchParams.get('email') || ''),
        organization: String(searchParams.get('organization') || ''),
      })}
      onClose={() => navigate('/users', { replace: true })}
      saveDisabled={!org?.id || isResolvingOrganization || Boolean(organizationResolutionError)}
      topMessage={
        organizationResolutionError ||
        (isResolvingOrganization ? 'Selecting organization...' : null) ||
        (!org?.id ? 'Please select an organization before continuing.' : null)
      }
      onSave={async (payload) => {
        try {
          if (!isValidEmail(payload?.email)) {
            return showToastError('The email address appears invalid.');
          }
          if (!org?.id) {
            return showToastError('An organization must be selected.');
          }

          await denyUserRequestToAccessOrganization({
            email: payload.email,
            organizationId: org.id,
          });

          showToastSuccess(`${payload.name} was sent a denial email.`);
          navigate('/users', { replace: true });
        } catch (error) {
          console.error(error);
          showToastError(
            getErrorMessage(
              error,
              'Something went wrong. Please try again, or submit a support ticket if the problem continues.',
            ),
          );
        }
      }}
    />
  );
}
